"use strict";
import helpers from "./_helpers";
import { Modal } from 'bootstrap';

const Media = () => {
    const init = () => {
        $(document).ready(function() {
            let el = document.getElementById('media');
            if (el) {
                let $form = $(el),
                  $sort = $form.find('#sort'),
                  $category = $form.find('#category'),
                  $dataContainer = $('#media-list'),
                  $formModal = $('#media-form .modal');

                $category.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='category']").val(val);

                    // Submit form to trigger ajax
                    $form.submit();

                    // Update visual states
                    $category.find('a.active').removeClass('active');
                    $form.find("a[data-category='" + val + "']").addClass('active');

                    if (val === "all") {
                        $category.parents('.form-group').removeClass('filled');
                        $category.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('category');
                    } else {
                        helpers.setUrlParameter('category', val);
                    }
                });

                $sort.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='sort']").val(val);

                    // Submit form to trigger ajax
                    $form.submit();

                    // Update visual states
                    $sort.find('a.active').removeClass('active');
                    $form.find("a[data-sort='" + val + "']").addClass('active');

                    if (val === "all") {
                        $sort.parents('.form-group').removeClass('filled');
                        $sort.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('sort');
                    } else {
                        helpers.setUrlParameter('sort', val);
                    }
                });

                const onItemClick = () => {
                    $dataContainer.find('.media-card').each(function() {
                        let $item = $(this),
                          id = $item.data('media-id'),
                          slug = $item.data('media-slug'),
                          fileValue = JSON.stringify({
                              id,
                              slug,
                          });
                        $item.click(function() {
                            $formModal.find('input[name="file"]').val(fileValue);
                        });
                    });
                };

                const pagination = () => {
                    $('.pagination a').each(function() {
                        $(this).click(function(e) {
                            e.preventDefault();
                            let href = $(this).attr('href');
                            let pageRegex = /page=(?<page>[0-9]+)/;
                            let groups = href.match(pageRegex).groups;
                            let page = groups.page;

                            if ($(this).attr('href') != '#') {
                                let navheight = $('header .navbar').outerHeight();
                                let top = $dataContainer.offset().top - navheight;
                                $("html, body").animate({scrollTop: top}, "fast");

                                // Update value
                                $("input[name='page']").val(page);

                                // Submit form to trigger ajax
                                $form.submit();

                                if (page === 1) {
                                    helpers.deleteUrlParameter("page");
                                } else {
                                    helpers.setUrlParameter("page", page);
                                }
                            }
                        });
                    });
                };

                $form.on('ajaxDone', function() {
                    pagination();
                    onItemClick();
                });

                $dataContainer.addClass('loaded');
                pagination();
                onItemClick();
            }
        });
    };

    const onDownload = (form) => {
        // Get value
        let data = JSON.parse($(form).find('input[name="file"]').val());

        // Submit download request
        window.location = '/media/download/' + data.slug;

        setTimeout(() => {
            $(form).find('.alert-success').removeClass('show');
            $(form).find('.alert-danger').removeClass('show');
        }, 2000);
    };

    return {
        init:init,
        onDownload:onDownload,
    };
};

export default Media;